
import React from 'react';
import moment from 'moment';
import formatNumber from '../../../helpers/NumberFormat';
import "./InterestAndFees.scss"

const tableData = [
    { description: "Accrued Interest (Credit)", amount: 0 },
    { description: "Interest Payable (Debit)", amount: 0 },
    { description: "Net Total (Credit - Debit)", amount: 0 },
    { description: "Other Charges/Expenses", amount: 0 },
    { description: "Deficit/Shortfall", amount: 0 },
];

export default function InterestAndFeesComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row p-3 reports-panel">
                    <h5 className="mb-5 mt-2" style={{ fontWeight: "500" }}>INTEREST AND FEES</h5>
                    <p className='text-muted'>Your account details are shown below.</p>

                    <div className="bg-custom-dark px-3 py-4 mb-3 rounded shadow-sm">
                        <h5 className="text-muted mb-4">Report Selection</h5>

                        <div className="row g-5">
                            <div className="col-md-6">
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex justify-content-between">
                                        <span>Registered To:</span>
                                        <strong>{main?.user?.first_name} {main?.user?.last_name}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Account Number:</span>
                                        <strong>{main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</strong>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex justify-content-between">
                                        <span>Available balance:</span>
                                        <strong>{formatNumber(main?.user?.balance)} €</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Account balance:</span>
                                        <strong>{formatNumber(main?.user?.balance)} €</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Credit limit:</span>
                                        <strong>{formatNumber(0)} €</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='mt-5 mb-4'>
                        <div className='text-muted'>
                            Please note that the data presented below is accurate as of <strong>{moment().format('D MMMM YYYY')}</strong>. Any transactions or changes made after this date may not be reflected.
                        </div>
                    </div>

                    <div className='row p-0 m-0'>
                        <div className='col-md-5' style={{ borderRight: "2px solid #EFEFEF" }}>
                            <h5>INTEREST AND EXPENSE BREAKDOWN</h5>
                            <p className={`text-muted my-5 ${isMobile && "text-center"}`}>You have no interest expenses to show.</p>
                        </div>
                        <div className='col-md-7'>
                            <h5>INTEREST SITUATION</h5>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className='table-head'>
                                        <tr>
                                            <th>Description</th>
                                            <th className="text-end">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.map((el) => (
                                            <tr>
                                                <td>{el.description}</td>
                                                <td className="text-end">{formatNumber(el.amount)} €</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className='mt-5 mb-3'>
                        <div className='text-muted'>
                            The data above corresponds to the current liquidation period. This information will be officially confirmed by the Bank upon the issuance of your periodic Account Statement.
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}